import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6daaac46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-3" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box-steps" }
const _hoisted_4 = { class: "description" }

import { IProduct } from '@/types/product';
  import StepCard from '../components/card-step.vue';

  interface IProps {
    product: IProduct;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    product: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppTabs, { class: "section-tab" }, {
        default: _withCtx(() => [
          _createVNode(_component_AppTab, { label: "HOW IT WORKS" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.work_steps, (step, index) => {
                  return (_openBlock(), _createBlock(StepCard, {
                    key: index,
                    index: index + 1,
                    icon: step.icon.url,
                    title: step.title,
                    description: step.description,
                    class: "step-card-item"
                  }, null, 8, ["index", "icon", "title", "description"]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_AppTab, { label: "Important Shipping Restrictions" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(__props.product.important_shipping_restrictions), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})